import { useEffect, useMemo } from 'react';
import { getOfficeLocations } from 'services/Settings';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'modules/cases/config/queryClient';

export const useOfficeLocation = (options = {}) => {
  const { isCase = false, isLeads = false } = options;

  // Build query key with all parameters for proper caching
  const queryKey = useMemo(() => {
    return queryKeys.officeLocations.list(isCase, isLeads);
  }, [isCase, isLeads]);

  // React Query hook
  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => {
      const response = await getOfficeLocations();
      return response?.data || [];
    },
    staleTime: isCase || isLeads ? 10 * 60 * 1000 : 5 * 60 * 1000, // 10 minutes for cases/leads, 5 minutes otherwise
    gcTime: isCase || isLeads ? 30 * 60 * 1000 : 15 * 60 * 1000, // 30 minutes for cases/leads, 15 minutes otherwise
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: true,
  });

  const officeLocationList = data || null;

  const modifiedOfficeLocationList = useMemo(() => {
    if (officeLocationList?.length > 0) {
      return officeLocationList.map((item) => {
        return item?.is_primary_office === 'true'
          ? {
              ...item,
              office_nameLabel: `${item.office_name} (Primary Office)`,
            }
          : {
              ...item,
              office_nameLabel: item.office_name,
            };
      });
    }
    return null;
  }, [officeLocationList]);

  return { officeLocationList, modifiedOfficeLocationList, isLoading, error };
};
